"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FullJitterBackoff_1 = require("../backoff/FullJitterBackoff");

var NoOpDebugLogger_1 = require("../logger/NoOpDebugLogger");

var NoOpMediaStreamBroker_1 = require("../mediastreambroker/NoOpMediaStreamBroker");

var MeetingSessionConfiguration_1 = require("../meetingsession/MeetingSessionConfiguration");

var MeetingSessionCredentials_1 = require("../meetingsession/MeetingSessionCredentials");

var MeetingSessionURLs_1 = require("../meetingsession/MeetingSessionURLs");

var DefaultReconnectController_1 = require("../reconnectcontroller/DefaultReconnectController");

var DefaultWebSocketAdapter_1 = require("../websocketadapter/DefaultWebSocketAdapter");

var DefaultAudioVideoController_1 = require("./DefaultAudioVideoController");

var NoOpAudioVideoController = /*#__PURE__*/function (_DefaultAudioVideoCon) {
  _inherits(NoOpAudioVideoController, _DefaultAudioVideoCon);

  var _super = _createSuper(NoOpAudioVideoController);

  function NoOpAudioVideoController(configuration) {
    _classCallCheck(this, NoOpAudioVideoController);

    var emptyConfiguration = new MeetingSessionConfiguration_1.default();
    emptyConfiguration.meetingId = '';
    emptyConfiguration.externalMeetingId = '';
    emptyConfiguration.credentials = new MeetingSessionCredentials_1.default();
    emptyConfiguration.credentials.attendeeId = '';
    emptyConfiguration.credentials.joinToken = '';
    emptyConfiguration.urls = new MeetingSessionURLs_1.default();
    emptyConfiguration.urls.turnControlURL = '';
    emptyConfiguration.urls.audioHostURL = '';
    emptyConfiguration.urls.screenViewingURL = '';
    emptyConfiguration.urls.screenDataURL = '';
    emptyConfiguration.urls.screenSharingURL = 'wss://localhost/';
    emptyConfiguration.urls.signalingURL = 'wss://localhost/';
    return _super.call(this, configuration ? configuration : emptyConfiguration, new NoOpDebugLogger_1.default(), new DefaultWebSocketAdapter_1.default(new NoOpDebugLogger_1.default()), new NoOpMediaStreamBroker_1.default(), new DefaultReconnectController_1.default(0, new FullJitterBackoff_1.default(0, 0, 0)));
  }

  _createClass(NoOpAudioVideoController, [{
    key: "setAudioProfile",
    value: function setAudioProfile(_audioProfile) {}
  }, {
    key: "start",
    value: function start() {}
  }, {
    key: "stop",
    value: function stop() {}
  }]);

  return NoOpAudioVideoController;
}(DefaultAudioVideoController_1.default);

exports.default = NoOpAudioVideoController;